import type { AccountInfo, IPublicClientApplication } from '@azure/msal-browser'
import { loginRequest } from '../../../configs'

export async function getToken(
  instance: IPublicClientApplication,
  account: AccountInfo | null,
): Promise<string> {
  if (!account) {
    return ''
  }
  try {
    const result = await instance.acquireTokenSilent({ ...loginRequest, account })
    return result.accessToken
  } catch {
    await instance.acquireTokenRedirect({ ...loginRequest, account })
    return ''
  }
}
